export default __webpack_public_path__ + "static/media/738.b86c3c8a.png";